var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0.171875C4.4775 0.171875 0 4.64937 0 10.1719C0 15.6944 4.4775 20.1719 10 20.1719C15.5225 20.1719 20 15.6944 20 10.1719C20 4.64937 15.5225 0.171875 10 0.171875ZM8.87417 5.58271C8.8075 4.91521 9.3325 4.33854 10 4.33854C10.6675 4.33854 11.1925 4.91521 11.1258 5.58271L10.4583 12.2577C10.4342 12.4927 10.2367 12.6719 10 12.6719C9.76333 12.6719 9.56583 12.4927 9.54167 12.2569L8.87417 5.58271ZM10 16.2135C9.425 16.2135 8.95833 15.7469 8.95833 15.1719C8.95833 14.5969 9.425 14.1302 10 14.1302C10.575 14.1302 11.0417 14.5969 11.0417 15.1719C11.0417 15.7469 10.575 16.2135 10 16.2135Z",
    fill: "#E86247"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningRed);
export default __webpack_public_path__ + "static/media/warning-red.3d459802f54ef6cc3fd1c549565d0a6b.svg";
export { ForwardRef as ReactComponent };